import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned a couple of things these days 22.8. 23.8. 24.8.",
  "description": "",
  "published": "2011-08-24T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-a-couple-of-things-these-days-22-8-23-8-24-8/swizec/2280"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The past couple of days have been consumed mostly by traveling from California to Slovenia. Apparently that takes a while.`}</p>
    <p>{`As a result I haven't been online for almost three days and what I was online for was mostly just arranging to meet a few people for various reasons. Therefore I haven't been posting my daily learnings ... so I'm going to post a batch of highlights since Monday.`}</p>
    <ol>
      <li parentName="ol">{`SFO does indeed have a mailbox. It's outside.`}</li>
      <li parentName="ol">{`Going on an internet diet was pretty damn cool, means I didn't get any cravings and was mostly fine for the whole flight across the Atlantic and when Amsterdam only had very spotty internet, I was mostly fine the whole five hours I spent there.`}</li>
      <li parentName="ol">{`It is apparently possible to use US dollars as a valid currency at a European airport. This was delightful because I had a bunch left still and wouldn't know what to do with them otherwise.`}</li>
      <li parentName="ol">{`Europe is fucking expensive! 4.9 euro for a bloody frappucino? Are you kidding me?`}</li>
      <li parentName="ol">{`Apparently when you are used to talking to someone on Skype a lot and then after two months they are suddenly real again it feels surprisingly awkward.`}</li>
      <li parentName="ol">{`This problem does not exist with people you only speak with online and have seen in person for a cumulative ten hours.`}</li>
      <li parentName="ol">{`Everything in Europe is ... small. Things like desks, cupboards, kitchen counters and such are very very very short. And I'm saying this as an extremely short person. Everything is just sooo far down it's weird. How doesn't everyone have insane back problems from leaning down all the time?`}</li>
    </ol>
    <p>{`Oh and just as a general observation. Summer weather in Slovenia sucks, I dislike it with a passion.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      